export const ALL_MANAGE_REPORT_REQUEST = "ALL_MANAGE_REPORT_REQUEST";
export const ALL_MANAGE_REPORT_SUCCESS = "ALL_MANAGE_REPORT_SUCCESS";
export const ALL_MANAGE_REPORT_FAIL = "ALL_MANAGE_REPORT_FAIL";